import React from 'react'
import Checkbox from 'components/Checkbox'

import FormSection from 'pages/shared/FormSection'

import Brand from 'helpers/brand'

interface BrandFieldsErrors {
  brands?: string
}

interface BrandFieldsProps {
  selectedBrands: string[]
  onChangeCallback: (update: { brands: string[] }) => void
  errors?: BrandFieldsErrors
}

const BrandFields = ({ selectedBrands, onChangeCallback, errors = {} }: BrandFieldsProps) => {
  const allBrands: string[] = Brand.allBrandsOfCurrentBusinessUnit()

  const onBrandChange = (brand: string) => {
    const updatedBrands = selectedBrands.includes(brand)
      ? selectedBrands.filter((selectedBrand) => selectedBrand !== brand)
      : [...selectedBrands, brand]

    onChangeCallback({ brands: updatedBrands })
  }

  return (
    <FormSection title="Brands">
      {
        allBrands.map((brand) => (
          <Checkbox
            key={brand}
            label={Brand.productName(brand)}
            checked={selectedBrands.includes(brand)}
            onChange={() => onBrandChange(brand)}
            errorMessage={allBrands[allBrands.length - 1] === brand ? errors.brands : ''}
          />
        ))
      }
    </FormSection>
  )
}

export default BrandFields
